import React from "react";

import hero from "../assets/images/homepage-image.png";
import { Button } from "@material-tailwind/react";


function Header() {
  const scrollToBottom = () => {
    const element = document.getElementById("form");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    
  };
  return (
    <div className="bg-gradient-to-b pt-[40px] 2xl:pt-[111px] h-[760px] 2xl:h-[320px] xl:h-[520px] from-[#402ea2] from-[11.60%] 2xl:pl-[100px] via-primary via-[60.82%] to-primary border-0 2xl:h-[584px]">
      <div className="2xl:float-left 2xl:pl-[100px] xl:pl-[100px] xl:pt-[50px]">
        <h1 className="text-center text-white break-words text-5xl 2xl:text-left 2xl:text-[62px] 2xl:w-[624px] xl:text-left xl:text-[62px] xl:w-[524px] z-30">
          Collect and trade your valuable phygital collectibles worldwide
        </h1>

        <div className="w-full 2xl:float-left 2xl:justify-start xl:w-[300px] flex-center">
          <Button
            className="normal-case z-30 rounded-25 bg-tertiary w-11/12 mb-6 mt-10 text-base 2xl:w-[300px]"
            onClick={scrollToBottom}
          >
            Get notified when we launch
          </Button>
        </div>
      </div>
      <div className=" 2xl:absolute 2xl:top-[140px] 2xl:left-[50%] xl:top-[100px] xl:left-[50%] xl:absolute	lg:left-[25%] md:left-[25%] relative">
        <img src={hero}  alt="Hero" />
      </div>
    </div>
  );
}
export default Header;
